import _ from 'lodash'

import { Select } from 'peach/components'
import { useParams } from 'peach/router'

import { useInternalListCaseTypes } from 'core/types'

// const caseTypes = [
//   'generic',
//   'bankruptcy',
//   'ceaseCommunication',
//   'collection',
//   'deceased',
//   'disputeOfDebt',
//   'federalEmergency',
//   'identityTheft',
//   'legalAction',
//   'militaryDuty',
//   'debtValidation',
// ]

const CaseTypeIdSelect = (props) => {
  const { companyId } = useParams<{ companyId?: string }>()

  const { data: caseTypes, isLoading } = useInternalListCaseTypes({ companyId })

  const options = _.map(caseTypes, ({ id, name }) => ({
    value: id,
    label: name,
  }))

  return <Select loading={isLoading} options={options} searchable {...props} />
}

export default CaseTypeIdSelect
